import React, { useState } from 'react';
import { X } from 'lucide-react';

// Import local gallery images
import galleryArbeitsbereich from '../assets/gallery-arbeitsbereich.jpg';
import galleryZimmer1 from '../assets/gallery-zimmer1.jpg';
import galleryBadOben1 from '../assets/gallery-bad-oben1.jpg';
import galleryBadOben2 from '../assets/gallery-bad-oben2.jpg';

const images = [
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/6puwovcr_1.jpg',
    alt: 'Villa mit Pool - A-Frame Design'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/f3wfw5k6_2.jpg',
    alt: 'Steg zum Wasser mit grünem Boot'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/h1hq06eo_3.jpg',
    alt: 'Pool mit Palmen und Seeblick'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/cjdi3uhn_4.jpg',
    alt: 'Welcome-Dekoration'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/t742rsqn_5.jpg',
    alt: 'Buddha und Thai-Dekoration'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/qzp1yh2l_6.jpg',
    alt: 'Villa Innenansicht mit Treppe'
  },
  {
    url: galleryZimmer1,
    alt: 'Schlafzimmer im Erdgeschoss'
  },
  {
    url: galleryArbeitsbereich,
    alt: 'Arbeitsbereich mit Schreibtisch'
  },
  {
    url: galleryBadOben1,
    alt: 'Badezimmer oben mit Badewanne'
  },
  {
    url: galleryBadOben2,
    alt: 'Badezimmer oben - Detailansicht'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/ov3qi372_7.jpg',
    alt: 'Schlafzimmer mit Klimaanlage'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/g7af5q97_8.jpg',
    alt: 'Wohnzimmer von oben mit Bar'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/hv69clbh_9.jpg',
    alt: 'Schlafzimmer mit A-Frame Fenster'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/r8bukx5e_10.jpg',
    alt: 'Ausblick auf Pool und See bei Sonnenuntergang'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/uojc3bpw_11.jpg',
    alt: 'Villa bei Nacht mit Pool-Beleuchtung'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/3jj3b2b6_12.jpg',
    alt: 'Villa Außenansicht mit Palmen'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/dgllsioj_13.jpg',
    alt: 'Palmen bei Sonnenuntergang'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/ljw9r1yy_14.jpg',
    alt: 'Villa Thailand Gästebuch'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/ee1z09gw_15.jpg',
    alt: 'Pool-Detailansicht'
  }
];

const PhotoGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openLightbox = (index) => {
    setSelectedImage(index);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const goToPrevious = (e) => {
    e.stopPropagation();
    setSelectedImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goToNext = (e) => {
    e.stopPropagation();
    setSelectedImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {images.map((image, index) => (
          <div
            key={index}
            className="relative aspect-[4/3] overflow-hidden rounded-xl shadow-lg cursor-pointer hover:shadow-2xl transition-shadow duration-300"
            onClick={() => openLightbox(index)}
          >
            <img
              src={image.url}
              alt={image.alt}
              className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              loading="lazy"
              draggable="false"
            />
          </div>
        ))}
      </div>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div 
          className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          {/* Close Button */}
          <button 
            className="absolute top-4 right-4 text-white hover:text-amber-400 transition-colors z-[101]"
            onClick={closeLightbox}
          >
            <X className="w-10 h-10" />
          </button>

          {/* Previous Button */}
          <button 
            className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:text-amber-400 transition-colors text-5xl font-light z-[101]"
            onClick={goToPrevious}
          >
            ‹
          </button>

          {/* Image */}
          <img
            src={images[selectedImage].url}
            alt={images[selectedImage].alt}
            className="max-h-[90vh] max-w-[90vw] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />

          {/* Next Button */}
          <button 
            className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-amber-400 transition-colors text-5xl font-light z-[101]"
            onClick={goToNext}
          >
            ›
          </button>

          {/* Image Counter */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white text-lg">
            {selectedImage + 1} / {images.length}
          </div>
        </div>
      )}
    </>
  );
};

export default PhotoGallery;
